import s from './getMarginBottomClass.module.scss';
import { SizeProp } from 'src/shared/types/props';

export const getMarginBottomClass = (size?: SizeProp): string | undefined => {
	return size ? s[`margin_${size}`] : undefined;
};
